export default [
  {
    label: "Administradores",
    href: "./"
  }
];